import {environment} from "environments";

{class TaskPhotosController {
    constructor($rootScope, $scope, Users, Auth, ngDialog, Logger, Media, Notifications, Orders, Constants, Photos, toastr) {
      'ngInject';

      Object.assign(this, {
        $rootScope,
        ngDialog,
        Users,
        Auth,
        Logger,
        Media,
        Notifications,
        Orders,
        Constants,
        Photos,
        toastr,
        isUserDeleted: false,
        waitingForUpload: false,
        isApproved: false,
        BOD_1220: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
      });
    }

    $onInit() {
      this.isUserDeleted = this.visit.user.status === 2;
      this.waitingForUpload = this.isAwaitingReupload();
      this.isApproved = this.isTaskApproved();
      this.init();
    }

    $doCheck() {
      this.isUserDeleted = this.visit.user.status === 2;
      this.waitingForUpload = this.isAwaitingReupload();
      this.isApproved = this.isTaskApproved();
  }

    init() {
      if (this.visit.needsDiagnosis()) {
        this.needsDiagnosis = true;
        this.Media.getLabels(this.visit).then(({ data }) => this.labels = data);
      } else {
        this.needsDiagnosis = false;
      }
    }

    reload() {
      this.onReload();
    }

    approve() {
      const payload = {
        photos: this.photos,
      };
      this.onApprove({ payload });
    }

    reject() {
      if (this.hasEmptyRejectionNote()) {
        this.errorMessage = 'Please provide a rejection message';
        return;
      }

      const payload = {
        photos: this.photos,
      };

      this.onReject({ payload });
    }

    hasEmptyRejectionNote() {
      const rejectedPhotosWithoutMessage = this.photos
        .filter(photo => photo.rejected && !photo.file.rejection_note);
      return rejectedPhotosWithoutMessage.length > 0;
    }

    isIdPhotoTask() {
      return this.task.type === this.Orders.TASKS.ID_PHOTO;
    }

    isAwaitingReupload() {
      return this.photos.some(photo =>
        photo.file && [this.Constants.PhotoStatuses.Rejected].includes(photo.file.status)
      );
    }

    isTaskApproved() {
      return this.hasPhotos() && this.photos.every(photo =>
        photo.file && [this.Constants.PhotoStatuses.Approved].includes(photo.file.status)
      );
    }

    isTaskPending() {
      return this.photos.every(photo =>
        photo.file && [this.Constants.PhotoStatuses.PendingReview].includes(photo.file.status)
      );
    }

    hasPhotos() {
      return this.photos.length
    }
//TODO
    openPhotoGallery(index = 0) {
      this.ngDialog.open({
        templateUrl: 'app/components/gallery/gallery.html',
        className: 'ngdialog-theme-default photo-dialog',
        controller: 'GalleryController',
        controllerAs: 'gallery',
        resolve: {
          files: () => this.photos,
          data: () => {
            return {
              index,
              requiresAction: this.requiresAction.bind(this),
            };
          },
        },
      });
    }
//TODO
    openDiagnosisReference() {
      this.ngDialog.open({
        templateUrl: 'app/views/visits/detail/sections/photos/photos.diagnosis.html',
        className: 'ngdialog-theme-default diagnosis-dialog',
        controllerAs: 'diagnosis',
        data: {
          image: `assets/images/${this.visit.service.code === 'HL' ? 'norwood_reference.gif' : 'acne_reference.png'}`,
        },
      });
    }

    hasRejected() {
      return !!_.find(this.photos, { rejected: true });
    }

    hasDeleted() {
      return this.photos.some(photo => photo.deleted);
    }

    requiresAction() {
      return this.isTaskPending() && !this.isApproved && !this.waitingForUpload;
    }

    isPhotoId(file) {
      return this.types && file.id === 13;
    }

    canPhotoBeDeleted(file) {
      const allowed_roles = [
        this.Users.ROLES.SUPER.NAME
      ];
      const my_roles = Object.values(this.Auth.profile.roles);
      const isAllowedToDelete = !!allowed_roles
        .filter(value => my_roles
          .includes(value)
        ).length;
      return this.isPhotoId(file) && !file.deleted && isAllowedToDelete;
    }

    deletePhoto(file) {
      this.Photos.deletePhoto(file.file.id)
        .then(() => {
          file.deleted = true;
          this.$rootScope.$emit('visit:photo-deleted', file);
        })
        .catch((err) => {
          this.toastr.error('Error changing store' + (err ? (': ' + err) : '.'));
        });
    }
//TODO
    showDeletePhotoConfirmationDialog(file) {
      this.ngDialog.open({
        template: 'app/components/task-photos/delete-photo-dialog/delete-photo-dialog-old.component.html',
        controller: 'DeletePhotoDialogComponent',
        controllerAs: 'vm',
        data: {
          file,
        },
        preCloseCallback: (res) => {
          if (res.approve) {
            this.deletePhoto(file);
          }
        },
      });
    }
  }
  TaskPhotosController.$inject = ["$rootScope", "$scope", "Users", "Auth", "ngDialog", "Logger", "Media", "Notifications", "Orders", "Constants", "Photos", "toastr"];
  angular.module('pims').component('taskPhotosOld', {
    templateUrl: 'app/components/task-photos/task-photos-old.html',
    controller: TaskPhotosController,
    bindings: {
      photos: '=',
      diagnosis: '=',
      task: '=',
      visit: '=',
      reviewer: '=',
      types: '<',
      errorMessage: '=?',
      disablecta: '=',
      onReload: '&',
      onReject: '&',
      onApprove: '&'
    }
  });
}
